"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TsEnvironmentDetect = exports.OSTypes = exports.Environments = void 0;
var ua_parser_js_1 = require("ua-parser-js");
var room_constants_1 = require("../constants/room.constants");
var utils_constant_1 = require("../constants/utils.constant");
var includes_1 = __importDefault(require("lodash/includes"));
var Environments;
(function (Environments) {
    Environments["desktop"] = "desktop";
    Environments["mobile"] = "mobile";
    Environments["phone"] = "phone";
    Environments["tablet"] = "tablet";
})(Environments = exports.Environments || (exports.Environments = {}));
var OSTypes;
(function (OSTypes) {
    OSTypes["Mac"] = "mac";
    OSTypes["Linux"] = "linux";
    OSTypes["Windows"] = "windows";
})(OSTypes = exports.OSTypes || (exports.OSTypes = {}));
/**
 * TsEnvironmentDetectService checks if the current browser is the
 * running in a mobile (phone, tablet) or desktop environment
 */
var TsEnvironmentDetect = /** @class */ (function () {
    function TsEnvironmentDetect(userAgent) {
        if (userAgent === void 0) { userAgent = ''; }
        this._parser = new ua_parser_js_1.UAParser(userAgent);
        this._deviceType = this._parser.getDevice().type;
        this._os = this._parser.getOS();
        this._osName = this._os.name;
        this._browser = this._parser.getBrowser();
    }
    TsEnvironmentDetect.prototype.getDisplayTabletAsDesktop = function (displayTabletAsDesktop) {
        return displayTabletAsDesktop === undefined
            ? !!(typeof localStorage === 'undefined' ? false : localStorage.getItem('displayTabletAsDesktop'))
            : displayTabletAsDesktop;
    };
    TsEnvironmentDetect.prototype.isWebRTCEnabledAppleDevice = function () {
        return !!(this.isIOS() && this._os && this._os.version && this._os.version >= '11.0');
    };
    TsEnvironmentDetect.prototype.getDeviceDetails = function () {
        return this._parser.getResult();
    };
    TsEnvironmentDetect.prototype.isDesktop = function (displayTabletAsDesktop) {
        // Unlike all other types of devices (mobile, tablet, smarttv, wearable, etc)
        // desktops and laptops are not identified as such. They simply have
        // an undefined type (which also happens on some Android tablets, though).
        // noinspection PointlessBooleanExpressionJS
        return !!((typeof this._deviceType === 'undefined' && !this.isAndroid()) ||
            (this.isTablet(displayTabletAsDesktop) && this.getDisplayTabletAsDesktop(displayTabletAsDesktop)));
    };
    // UAParser uses 'mobile' for phones, but we also want the ability to test
    // for devices that are either phones or tablets and these are generally
    // called 'mobile'. so isMobile means deviceType equals to 'mobile', 'tablet'
    // or osName === Android (since some android tablet report deviceType 'udefined')
    TsEnvironmentDetect.prototype.isMobile = function (displayTabletAsDesktop) {
        return (this.isPhone() ||
            (this.isTablet(displayTabletAsDesktop) && !this.getDisplayTabletAsDesktop(displayTabletAsDesktop)));
    };
    TsEnvironmentDetect.prototype.isPhone = function () {
        return this._deviceType === 'mobile';
    };
    TsEnvironmentDetect.prototype.isTablet = function (displayTabletAsDesktop) {
        return (this.getDisplayTabletAsDesktop(displayTabletAsDesktop) ||
            (this._deviceType === 'undefined' && this.isAndroid()) ||
            this._deviceType === 'tablet');
    };
    TsEnvironmentDetect.prototype.isAndroid = function () {
        return this._osName === 'Android';
    };
    TsEnvironmentDetect.prototype.isIOS = function () {
        return this._osName === 'iOS';
    };
    TsEnvironmentDetect.prototype.isIE11 = function () {
        return this._browser.name === 'IE' && this._browser.major === '11';
    };
    TsEnvironmentDetect.prototype.isChrome = function () {
        return this._browser.name === 'Chrome';
    };
    TsEnvironmentDetect.prototype.isFF = function () {
        return this._browser.name === 'Firefox';
    };
    TsEnvironmentDetect.prototype.isSafari = function () {
        return includes_1.default(this._browser.name, 'Safari');
    };
    TsEnvironmentDetect.prototype.isEdge = function () {
        return this._browser.name === 'Edge';
    };
    TsEnvironmentDetect.prototype.majorVersion = function () {
        return parseInt(this._browser.major || '', 10);
    };
    TsEnvironmentDetect.prototype.browserVersion = function () {
        return this._browser.version || '';
    };
    TsEnvironmentDetect.prototype.deviceType = function () {
        return this._deviceType;
    };
    TsEnvironmentDetect.prototype.deviceCategory = function (displayTabletAsDesktop) {
        if (this.isTablet(displayTabletAsDesktop)) {
            return utils_constant_1.DeviceCategory.tablet;
        }
        else if (this.isMobile(displayTabletAsDesktop)) {
            return utils_constant_1.DeviceCategory.phone;
        }
        else if (this.isDesktop(displayTabletAsDesktop)) {
            return utils_constant_1.DeviceCategory.desktop;
        }
        return null;
    };
    // Category for viewing (for example, tablet might get desktop view)
    TsEnvironmentDetect.prototype.deviceCategoryForView = function (displayTabletAsDesktop) {
        if (this.isDesktop(displayTabletAsDesktop)) {
            return utils_constant_1.DeviceCategory.desktop;
        }
        else if (this.isMobile(displayTabletAsDesktop)) {
            return utils_constant_1.DeviceCategory.phone;
        }
        else if (this.isTablet(displayTabletAsDesktop)) {
            return utils_constant_1.DeviceCategory.tablet;
        }
        return null;
    };
    TsEnvironmentDetect.prototype.os = function () {
        return this._os;
    };
    TsEnvironmentDetect.prototype.osName = function () {
        return this._osName;
    };
    TsEnvironmentDetect.prototype.isLinux = function () {
        var clientOs = this._osName && this._osName.toLowerCase();
        return !!(clientOs && clientOs.includes(OSTypes.Linux));
    };
    TsEnvironmentDetect.prototype.isMac = function () {
        var clientOs = this._osName && this._osName.toLowerCase();
        return !!(clientOs && clientOs.includes(OSTypes.Mac));
    };
    TsEnvironmentDetect.prototype.isWindows = function () {
        var clientOs = this._osName && this._osName.toLowerCase();
        return !!(clientOs && clientOs.includes(OSTypes.Windows));
    };
    TsEnvironmentDetect.prototype.browser = function () {
        return this._browser;
    };
    TsEnvironmentDetect.prototype.isEnvironment = function (env, displayTabletAsDesktop) {
        return ((env === Environments.desktop && this.isDesktop(displayTabletAsDesktop)) ||
            (env === Environments.mobile && this.isMobile(displayTabletAsDesktop)) ||
            (env === Environments.phone && this.isPhone()) ||
            (env === Environments.tablet && this.isTablet(displayTabletAsDesktop)));
    };
    TsEnvironmentDetect.prototype.isApplicationWebView = function (ref) {
        return includes_1.default([room_constants_1.Referrer.ANDROID_APPLICATION, room_constants_1.Referrer.IOS_APPLICATION], ref);
    };
    TsEnvironmentDetect.prototype.isAudioSupported = function () {
        return !this.isIOS() || (this.isIOS() && this.isSafari());
    };
    return TsEnvironmentDetect;
}());
exports.TsEnvironmentDetect = TsEnvironmentDetect;
